<template>
  <div class="virtual-booth-holder" ref="virtualBoothHolder">
    <transition name="fade" mode="out-in">
      <template>
        <BoothForm
          key="3"
          v-if="site_config.use_intro_form && show_booth_form"
        />
      </template>
    </transition>
    <UnityContainer />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import BoothEntry from "../components/BoothEntry";
import UnityContainer from "./ContentContainer";
import { page } from "vue-analytics";
import BoothForm from "../components/BoothForm";

import hotkeys from "hotkeys-js";

export default {
  name: "LandingPage",
  components: {
    BoothForm,
    BoothEntry,
    UnityContainer
  },
  data() {
    return {
      video_clicked: false
    };
  },
  computed: {
    ...mapState(["app_type", "page_state", "browser_is_mobile", "site_config"]),
    ...mapGetters(["eventTag"]),
    can_show_video_block() {
      //show video when it's configured to show a video
      //when we're not showing the booth form
      //and when we don't need to show the mobile intro screen.
      //page state is 0 before the form displays
      return (
        this.site_config.use_intro_video &&
        !this.show_booth_form &&
        this.page_state < 1
      );
    },
    can_show_video_cover() {
      //the video cover can be configured in the store file
      //should display if it hasn't been clicked on yet

      return (
        this.site_config.use_intro_image &&
        this.page_state == 0 &&
        this.video_clicked == false
      );
    },
    show_booth_form() {
      return (
        this.$store.state.page_state == 1 ||
        (this.$store.state.page_state == 2 && this.$store.state.app_state < 0)
      );
    },
    unity_progress() {
      return this.$store.state.unity_progress * 100 + "%";
    },
    progress_bar_style() {
      return "width:" + this.unity_progress;
    }
  },
  methods: {
    //play the video after you click on the cover
    on_video_cover_clicked(e) {
      e.preventDefault();
      this.video_clicked = true;
      this.$refs.intro_video.play();
    },

    //when the video ends we decide whether
    //we should show the form or go directly to the content
    on_video_end() {
      if (this.site_config.use_intro_form) {
        this.$store.dispatch("set_page_state", 1);
      } else {
        this.$store.dispatch("set_page_state", 2);
        this.$store.dispatch("set_app_state", 0);
      }
    },

    //helper function to use while dev
    //so we don't need to watch the video multiple times
    skip_video() {
      this.$refs.intro_video.pause();
      this.on_video_end();
    },
    on_request_booth_resize(el) {
      //console.log(
      //   "resize to booth",
      //   this.$refs.virtualBoothHolder,
      //   this.$refs.virtualBoothHolder.clientHeight
      // );
      // el.style.height = "10vh";
      // el.style.height = this.$refs.virtualBoothHolder.clientHeight + "px";
    }
  },
  mounted() {
    this.$bus.$on("on-request-booth-resize", this.on_request_booth_resize);

    this.$ga.page("/" + this.eventTag + "/");

    //if we have a video but no cover, start the video immediately
    //if we have no video, then we trigger the video end function
    //which should either show the form or go to content
    if (this.site_config.use_intro_video && !this.site_config.use_intro_image) {
      this.video_clicked = true;
      this.$refs.intro_video.play();
    } else if (!this.site_config.use_intro_video) {
      this.on_video_end();
    }

    hotkeys(
      "ctrl+shift+s, command+shift+s",
      function () {
        console.log(this.$store.state.popup_state);
        if (
          this.$store.state.page_state == 0 ||
          this.$store.state.page_state == 1
        ) {
          this.skip_video();
        }
      }.bind(this)
    );
  }
};
</script>

<style scoped>
.unity_progress_bar {
  height: 4px;
  background: #ddd;
  overflow: hidden;
  position: absolute;
  width: 100%;
  top: 0;
}
.unity_progress {
  background: #fb0000;
  height: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.6s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.video-container {
  width: 100%;
}

.video-container video,
.video-container img {
  width: 100%;
  max-height: 70vh;
}
.video-container img {
  object-fit: contain;
}
.video-container .video-intro-link {
  position: absolute;
}
</style>



// WEBPACK FOOTER //
// src/components/LandingPage.vue